import javaLogo from '../assets/java.png';
import kotlinLogo from '../assets/kotlin.png';
import reactLogo from '../assets/react.png';
import dockerLogo from '../assets/Docker.png';
import pythonLogo from '../assets/python.png';
import {
  SiBootstrap,
  SiDocker,
  SiGit,
  SiGithub,
  SiJavascript,
  SiKotlin,
  SiLaravel,
  SiMysql,
  SiNodedotjs,
  SiPhp,
  SiPostgresql,
  SiReact,
  SiRedis,
  SiRender,
  SiSpringboot,
  SiVercel,
} from '@icons-pack/react-simple-icons';

export const SKILLS = [
  { name: 'Java', logo: javaLogo, detail: 'Backend services and dependable application logic.' },
  { name: 'Kotlin', icon: SiKotlin, color: '#a97bff', detail: 'Android experiences with clean, expressive code.' },
  { name: 'Spring Boot', icon: SiSpringboot, color: '#72bd4b', detail: 'REST services, authentication, and Java application APIs.' },
  { name: 'PostgreSQL', icon: SiPostgresql, color: '#82a7e9', detail: 'Structured data for reliable application workflows.' },
  { name: 'Docker', icon: SiDocker, color: '#2496ed', detail: 'Consistent environments from development to delivery.' },
  { name: 'MySQL', icon: SiMysql, color: '#70b7d7', detail: 'Relational data for web application backends.' },
  { name: 'Redis', icon: SiRedis, color: '#ff5f55', detail: 'Fast caching in planned application architecture.' },
  { name: 'React', icon: SiReact, color: '#61dafb', detail: 'Responsive interfaces and thoughtful interactions.' },
  { name: 'JavaScript', icon: SiJavascript, color: '#f7df1e', detail: 'Interactive behavior across modern web applications.' },
  { name: 'Bootstrap', icon: SiBootstrap, color: '#a276e7', detail: 'Responsive UI foundations and reusable components.' },
  { name: 'PHP', icon: SiPhp, color: '#a6a9d8', detail: 'Server-side application development.' },
  { name: 'Laravel', icon: SiLaravel, color: '#ff5a52', detail: 'Backend workflows for the talent-management platform.' },
  { name: 'Node.js', icon: SiNodedotjs, color: '#83c56b', detail: 'JavaScript tooling and server-side development.' },
  { name: 'Git', icon: SiGit, color: '#f37054', detail: 'Version control throughout the development process.' },
  { name: 'GitHub', icon: SiGithub, color: '#f5f5f5', detail: 'Collaboration and project source management.' },
  { name: 'Vercel', icon: SiVercel, color: '#f5f5f5', detail: 'Deploying web experiences.' },
  { name: 'Render', icon: SiRender, color: '#a4efcf', detail: 'Hosting application services.' },
];

export const TECH_STACK_ICONS = {
  Java: { logo: javaLogo },
  Kotlin: { logo: kotlinLogo },
  React: { logo: reactLogo },
  Docker: { logo: dockerLogo },
  Python: { logo: pythonLogo },
  'Spring Boot': { logo: `${process.env.PUBLIC_URL}/springboot.png` },
  PostgreSQL: { logo: `${process.env.PUBLIC_URL}/pg.svg` },
};
